import * as DesignSystemTokens from '@banenor/design-system-tokens'

export const Tokens = DesignSystemTokens

export const M40Tokens = {
  header: {
    backgroundColor: Tokens.BnColorBackgroundPrimaryOnDark,
  },
}
